import { action, IObservableArray, makeObservable, observable } from 'mobx';

class GlobalNav {
    navStack: IObservableArray<HTMLElement> = observable.array([]);

    @observable
    showGlobalNav = false;

    @action
    pushNav(el: HTMLElement) {
        this.navStack.push(el);
    }

    @action
    popNav() {
        return this.navStack.pop();
    }

    @action
    hideNav() {
        this.showGlobalNav = false;
    }

    @action
    showNav() {
        this.showGlobalNav = true;
    }

    constructor() {
        makeObservable(this);
    }
}

const globalNav = new GlobalNav();

export default globalNav;
